import styled, { css } from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { ThemedProperties } from '@r1-frontend/ui-kit/themes/types';

interface IProps {
    btnText: string | undefined,
    onClickContinue: () => void,
}

const SpecialOffer = styled(({ btnText = 'Продолжить онлайн', onClickContinue, ...props }: IProps): JSX.Element => (
    <div data-test='special-offer' {...props}>
        <Paragraph4 $color={COLORS.TextWhite} data-test='special-offer-title'>
            Доставка и&nbsp;подключение с&nbsp;бонусом&nbsp;&mdash; только при оформлении онлайн
        </Paragraph4>
        <Button
            bType='white'
            onClick={onClickContinue}
            data-test='special-offer-button'
        >
            {btnText}
        </Button>
    </div>
))`
    ${({ theme }: ThemedProperties) => css`
        display: flex;
        flex-direction: column;
        align-items: stretch;

        gap: ${theme.indents.s}px;
        padding: ${theme.indents.s}px ${theme.indents.m}px ${theme.indents.m}px;

        background: url(${require('@static/images/bp42/special-offer/rouble-bg-mobile.svg')}) no-repeat ${COLORS.Locked};

        @media (min-width: ${theme.breakpoints.mobile}) {
            flex-wrap: nowrap;
            flex-direction: row;
            align-items: flex-start;

            padding: ${theme.indents.s}px ${theme.indents.l}px ${theme.indents.m}px;

            background-image: url(${require('@static/images/bp42/special-offer/rouble-bg.svg')});
        }
    `};
`;

SpecialOffer.displayName = 'Bp42_SpecialOffer';

export default SpecialOffer;
